import HardwareFeaturesFa from './HardwareFeatures-fa.json';
import HardwareFeaturesEn from './HardwareFeatures-en.json';
import HardwareFeaturesAr from './HardwareFeatures-ar.json';
import HardwareFeaturesTr from './HardwareFeatures-tr.json';

export const hardwareFeaturesLocales = {
    fa: HardwareFeaturesFa,
    en: HardwareFeaturesEn,
    ar: HardwareFeaturesAr,
    tr: HardwareFeaturesTr,
};